module.exports = __webpack_public_path__ + "static/media/lene-k.236ef6e3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/lene-k.jpeg
// module id = 926
// module chunks = 0